import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getTodayTimeStr, getTodayTime, isAllowedDate } from '../util';
import dayjs from '../dayjs';
injectStyle("components/DatePicker/rc-calendar/style/common/TodayButton.css", "[data-dui-0-122-5~=\"dui-calendar-today-btn\"]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:4px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;color:var(--text-strong,rgba(0,0,0,.64));font-size:12px;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer}[data-dui-0-122-5~=\"dui-calendar-today-btn-icon\"]{margin-right:4px;width:16px;height:16px;background-size:contain;background-repeat:no-repeat;background-position:50%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none'%3E%3Cpath fill-rule='evenodd' d='M7 0h2v1.071A7.004 7.004 0 0114.929 7H16v2h-1.071A7.003 7.003 0 019 14.929V16H7v-1.071A7.003 7.003 0 011.071 9H0V7h1.071A7.003 7.003 0 017 1.071V0zm1 2.25a5.75 5.75 0 110 11.5 5.75 5.75 0 110-11.5zM8 10a2 2 0 100-4 2 2 0 100 4z' fill='%2381868f'/%3E%3C/svg%3E\")}[data-dui-0-122-5~=\"dui-calendar-today-btn\"]:hover{background:var(--feedback-hover,rgba(51,77,102,.06))}[data-dui-0-122-5~=\"dui-calendar-today-btn\"]:active{background:var(--feedback-active,rgba(51,77,102,.08))}[data-dui-0-122-5~=\"dui-calendar-today-btn-disabled\"]{color:rgba(0,0,0,.24)}");
var emptyFn = function () { };
export default function TodayButton(_a) {
    var _b;
    var prefixCls = _a.prefixCls, locale = _a.locale, value = _a.value, timePicker = _a.timePicker, disabled = _a.disabled, disabledDate = _a.disabledDate, onToday = _a.onToday, text = _a.text;
    var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
    var disabledToday = disabledDate && !isAllowedDate(getTodayTime(value), disabledDate);
    var isDisabled = disabledToday || disabled;
    return (h("div", { role: "button", tabIndex: "0", title: getTodayTimeStr(value), className: classNames(prefixCls + "-today-btn", (_b = {},
            _b[prefixCls + "-today-btn-disabled"] = isDisabled,
            _b)), onClick: isDisabled ? null : onToday },
        h("div", { className: classNames(prefixCls + "-today-btn-icon") }),
        localeNow));
}
TodayButton.propTypes = {
    disabled: PropTypes.bool,
    disabledDate: PropTypes.func,
    locale: PropTypes.shape({
        now: PropTypes.string,
        today: PropTypes.string,
    }),
    prefixCls: PropTypes.string,
    text: PropTypes.string,
    timePicker: PropTypes.element,
    value: PropTypes.instanceOf(dayjs),
    onToday: PropTypes.func,
};
TodayButton.defaultProps = {
    disabled: false,
    disabledDate: undefined,
    locale: {},
    onToday: emptyFn,
    prefixCls: '',
    text: '',
    timePicker: null,
    value: undefined,
};
